/**
 * @module app.shared
 */

import { IFormatter, IFormatOptions } from 'app/shared/lib/formatting/formatting-types';
import { translateList } from 'app/shared/lib/i18n';
import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { convertToStringArray, convertToString } from 'app/shared/lib/utilities';

export class OptionalFormatter implements IFormatter {

    constructor() { }

    public formatValue(value: unknown, options?: IFormatOptions): any {
        if(value) { return value; }

        // TODO: must return space in this version of i18next to prevent warning about missing interpolated value
        return options && options.format || ' ';
    }

}

export class TemplateFormatter implements IFormatter {

    constructor() { }

    public formatValue(value: unknown, options?: IFormatOptions): any {
        if(value === null || value === undefined) { return null; }

        const format = options && options.format;
        if(!format) { return value; }

        let stringValue = convertToString(value);

        // trim single quotes
        let template = format;
        if(template.startsWith("'") && template.endsWith("'")) {
            template = template.substr(1, template.length - 2);
        }

        // replace ~ with actual value
        return template.replace(/~/g, stringValue);
    }

}

@autoinject
export class ListTextFormatter implements IFormatter {

    constructor(protected readonly i18n: I18N) { }

    public formatValue(value: unknown, options?: IFormatOptions): any {
        if(value === null || value === undefined) { return null; }

        const conjunction = options && options.format || 'and';
        const list = convertToStringArray(value, false);
        if(list.length === 0) { return null; }

        return translateList(this.i18n, list, conjunction);
    }

}

@autoinject
export class CapitalizeFormatter implements IFormatter {

    constructor(protected readonly i18n: I18N) { }

    public formatValue(value: unknown, options?: IFormatOptions): any {
        if(value === null || value === undefined) { return null; }

        const style = options && options.format || 'all';
        const text = convertToString(value);

        // preserve spaces while splittig on whitespace
        const parts = text.split(/(\s+)/);
        const isWhitespace = /\s+/;
        let wordIndex = 0;
        for(let index = 0; index < parts.length; index++) {
            if(isWhitespace.test(parts[index])) { continue; }

            // TODO: 'title' case too complicated?
            if(style === 'all' || (style === 'first' && wordIndex === 0)) {
                parts[index] = this.capitalize(parts[index], options && options.language);
            }
            wordIndex++;
        }
        return parts.join('');
    }

    private capitalize(text: string, language?: string): string {
        const first = (<any>text.charAt(0)).toLocaleUpperCase(language); // typings don't have the locale parameter
        const rest = text.substr(1);
        return `${first}${rest}`;
    }

}
